<template>
  <div id="main-header">
    <div class="cover" :style="bgStyle"></div>
    <div id="nav">
      <div id="header-content">
        <div>
          <button
            class="btn"
            v-if="installPromptActive"
            id="install-button"
            small
            color="rgba(240,240,240,0.8)"
            @click="installPWA"
          >
            {{ $store.state.user.langEng ? "Install" : "Installera" }}
          </button>
        </div>

        <div class="header-buttons">
          <div title="flag" id="flag-button" @click="toggleLanguage">
            <transition
              name="animated-flag"
              mode="out-in"
              enter-active-class="animated pulse"
            >
              <img :src="languageFlag" :key="languageFlag" />
            </transition>
          </div>

          <EducationDropdown id="educations" />
          <profile-dialog id="login" />
        </div>

        <a href="/"
          class="class-tag center"
          @click.prevent="resetArticles"
        >
          <h4 id="schoolname">{{ schoolName }}</h4>
          <h2 id="classname">{{ className }}</h2>
          <!-- INSTALL BUTTON -->
          <!-- <v-btn>{{$store.state.user.langEng ? 'Install' : 'Installera'}}</v-btn> -->
        </a>

        <div id="header-inputs">
          <div id="header-favorites">
            <button class="btn-flat favorites white-text right">
              <i class="material-icons favorite-star" @click="toggleFavorites"
                >menu</i
              >
            </button>
          </div>

          <div class="input-fields">
            <search-article />
            <search-category />
          </div>

          <div id="header-notifications"> <button
              class="btn-flat notifications white-text left"
              v-if="$route.name == 'createArticle'"
            >
              <i class="material-icons clock-icon" @click="toggleNotifications">
                dashboard
              </i>
            </button>
            <button
              class="btn-flat notifications white-text left"
              :class="{ disabled: disableNotifications }"
              v-else-if="false"
            >
              <i class="material-icons clock-icon" @click="toggleNotifications">
                {{
                  disableNotifications ? "notifications_off" : "notifications"
                }}
              </i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import flagEng from "@/assets/img/flag-eng.png";
import flagSwe from "@/assets/img/flag-swe.png";
import { eventBus } from "@/main";
import $ from "jquery";

@Component({
  components: {
    SearchCategory: () => import("./SearchCategory"),
    SearchArticle: () => import("./SearchArticle"),
    ProfileDialog: () => import("./ProfileDialog"),
    EducationDropdown: () => import("./EducationsDropdown")
  },
})
export default class MainHeader extends Vue {
  backgroundImage = localStorage['background-image'] || ''
  installPromptActive = false;

  @Watch("$store.state.cover")
  onCoverChange(newVal) {
    setTimeout(() => {
      this.backgroundImage = newVal;
      localStorage['background-image'] = newVal
    }, 10);
  }

  async installPWA() {
    window.installPrompt.prompt();
    await window.installPrompt.userChoice;
    this.installPromptActive = false;
    window.installPrompt = null;
  }

  get bgStyle() {
    return `background-image: url("${this.backgroundImage}")`;
  }

  get className() {
    return this.$store.state.currentKlassName;
  }

  get schoolName() {
    return this.$store.state.currentSchoolName;
  }

  get languageFlag() {
    return this.$store.state.user.langEng ? flagEng : flagSwe;
  }

  get disableNotifications() {
    return true;
    // return this.$route.path.split("/")[1] === "create-article";
  }

  resetArticles() {
    this.$route.fullPath !== '/' && this.$router.push('/').catch(() => {})
    this.$store.commit("forceNewSearch");
  }

  toggleFavorites() {
    let elem = document.querySelector(".sidenav-left");
    this.$M.Sidenav.getInstance(elem).open();
  }

  toggleNotifications() {
    let elem = document.querySelector(".sidenav-right");
    this.$M.Sidenav.getInstance(elem).open();
  }

  toggleLanguage() {
    this.$store.commit("toggleLanguage");
    setTimeout(() => {
      let elems = document.querySelectorAll("select");
      this.$M.FormSelect.init(elems);
    }, 0);
  }

  @Watch("$store.state.isMobile")
  watchIsMobile() {
    this.stickyHeader();
  }

  stickyHeader() {
    if (window.innerWidth <= 600) {
      if (window.pageYOffset >= $("#nav").height() - 46) {
        $("#nav").addClass("sticky");
        $(".cover").addClass("sticky");
        $(".left-drawer, .right-drawer").addClass("sticky-drawers");
        $("#main-content").addClass("fix-screen");
      } else {
        $("#nav").removeClass("sticky");
        $(".cover").removeClass("sticky");
        $(".left-drawer, .right-drawer").removeClass("sticky-drawers");
        $("#main-content").removeClass("fix-screen");
      }
    } else if (window.pageYOffset >= $("#nav").height() - 56) {
      $("#nav").addClass("sticky");
      $(".cover").addClass("sticky");
      $(".left-drawer, .right-drawer").addClass("sticky-drawers");
      $("#main-content").addClass("fix-screen");
    } else {
      $("#nav").removeClass("sticky");
      $(".cover").removeClass("sticky");
      $(".left-drawer, .right-drawer").removeClass("sticky-drawers");
      $("#main-content").removeClass("fix-screen");
    }
  }

  get landscape() {
    return this.isMobile && window.innerWidth > window.innerHeight;
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  mounted() {
    $(window).scroll(this.stickyHeader);

    eventBus.$on("installPromptFired", () => {
      this.installPromptActive = true;
    });
  }

  beforeDestroy() {
    $(window).unbind("scroll");
    eventBus.$off("installPromptFired");
  }
}
</script>

<style scoped lang="scss">
.header-buttons {
  display: grid;
  grid-template-columns: 1fr 8em 5em;
  padding: 0 10px;
  height: 0;
  z-index: 2;
}

#flag-button {
  width: 2em;
}

.cover {
  position: fixed;
  background-size: cover;
  background-position: top;
  width: 100%;
  height: 257px;
  z-index: 0;
}

#nav {
  height: 257px;
  #header-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    margin: 0;
    z-index: 5;
    #header-inputs {
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      display: grid;
      grid-template-columns: 230px 1fr 230px;
      column-gap: 5px;
      margin-bottom: 0;
      padding: 0.5em 0;
      width: 100vw;
      z-index: 1;
      .favorites {
        display: none;
      }
      .notifications {
        display: none;
      }
      .input-fields {
        display: grid;
        grid-template-columns: 1fr 1fr;
        .search-input-wrapper {
          grid-column: 1/2;
          grid-row: 1/2;
          margin-right: 0.25em;
        }
        .select-container {
          grid-column: 2/3;
          grid-row: 1/2;
          margin-left: 0.25em;
        }
      }
      .btn-flat {
        padding: 0;
      }
    }
    .class-tag {
      display: flex;
      flex-direction: column;
      padding: 3em 0;
      z-index: 1;
      #classname,
      #schoolname {
        color: white;
        cursor: pointer;
        font-weight: bold;
        text-shadow: 1px 0px 6px #000000;
      }
      #classname {
        font-size: 4em;
      }
      #schoolname {
        font-size: 2em;
      }
    }
  }
}

@media (max-width: 992px) {
  #nav {
    height: 230px;
    #header-content {
      #header-inputs {
        grid-template-columns: 1fr 5fr 1fr !important;
        justify-content: center;
        margin: 0;
        .input-fields {
          grid-column: 2/3;
        }
        .favorites, .notifications {
          line-height: 40px;
          display: block !important;
        }
        i {
          font-size: 2.3em;
        }
      }
      .class-tag {
        #classname {
          font-size: 3em;
        }
        #schoolname {
          font-size: 1.5em;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  #header-content {
    #header-inputs {
      column-gap: 0;
      #header-favorites,
      #header-notifications {
        align-self: flex-end !important;
        justify-self: center;
      }
    }
    .input-fields {
      grid-template-columns: 1fr !important;
      row-gap: 10px;
      .search-input-wrapper {
        grid-column: 1/2 !important;
        grid-row: 2/3 !important;
        margin: 0 !important;
      }
      .select-container {
        grid-column: 1/2 !important;
        grid-row: 1/2 !important;
        margin: 0 !important;
      }
    }
    .class-tag {
      padding: 3em 0 1em !important;
      #classname {
        font-size: 2em !important;
      }
      #schoolname {
        font-size: 1em !important;
      }
    }
  }
}
</style>
